@@ -1,352 +0,0 @@

<!-- BARRA DE MENU FRENTE DE CAIXA -->

<script>
import { SysVars } from "../main";
import { zeroPad } from "../shared/utils";

export default {
  props: {
    pedv: "",
    params_colors: {},
    params_msg: "",
    caixa: "",
    showBtnConfig: { type: Boolean, default: true },
    config: Boolean,
    part: ""
  },
  data() {
    return {
      currVideo: null,
      isFullScreen: false
    };
  },

  computed: {
    hasFontconfig() {
      if (this.config) {
        if (this.params_colors.bg_top_bottom) {
          return `color:${this.params_colors.bg_top_bottom};`;
        }
        return `color:#174b79;`;
      }
      return "color:#174b79;";
    },
    hasBgconfig() {
      return `background-color: ${
        this.params_colors.bg_top_bottom
          ? this.params_colors.bg_top_bottom
          : "#174b79"
      }; color:${
        this.params_colors.fc_top_bottom
          ? this.params_colors.fc_top_bottom
          : "white;"
      }!important; border-bottom: 1px solid #e9e5e5; height: 45px; border-bottom-left-radius: 5px;`;
    },
    usuarionome: function() {
      return this.$store.getters.getEnv.usuarionome;
    },
    empresanome: function() {
      return this.$store.getters.getEnv.empresanome;
    },
    empresacod: function() {
      return zeroPad(this.$store.getters.getEnv.empresacod, 6);
    },
    email: function() {
      return this.$store.getters.getEnv.email;
    },
    acessoCore: function() {
      return this.$store.getters.getEnvAcessoCore;
    },
    istrial: function() {
      return this.$store.getters.getSessao.istrial == "S";
    },
    app: function() {
      if (SysVars.appNFe) return "nfe";
      else if (SysVars.appForcaVendas) return "forcaVendas";
    },
    url_router: function() {
      return this.$route.name;
    },
    helpList: function() {
      let list = this.$store.getters.getHelpList;
      return list.filter(obj => {
        return obj.app.indexOf(this.app) > -1 && obj.route == this.url_router;
      });
    },
    administrador: function() {
      return SysVars.usuarioAdministrador;
    }
  },

  methods: {
    clickAction(action) {
      this.$emit("action", action);
    },

    handleManual() {
      window.open(
        "https://s3.amazonaws.com/htdti/Gestor/NBManual.pdf", "_blank");
    },

    handleClose() {
      this.$emit('logout')
    },

    handleCentral() {
      window.open("http://notabrasil.com.br/suporte/", "_blank");
    },

    handleConfig() {
      this.$emit("config");
    },

    handleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        this.isFullScreen = true;
      } else {
        document.exitFullscreen();
        this.isFullScreen = false;
      }
    },
    handleHome() {
      this.$router.push({ path: "/" });
    }
  },

  created() {}
};
</script>

<template>
  <div>
    <nav
      class="d-flex align-itens-center m-0 p-0"
      style="background-color: white; height: 45px;"
    >
      <!-- <button
        v-if="showBtnConfig"
        :style="hasFontconfig"
        @click="handleConfig"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="fa fa-cog"></span>
      </button> -->
      <div
        class="col-3 row"
        style="max-width:240px!important; border-top-right-radius: 5px;"
      >
        <a class="navbar-brand m-0 p-0" href="/">
          <img
            src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo1.png"
            class="img-fluid px-2"
            style="max-height:40px!important;"
          />
        </a>
      </div>

      <div class="w-100 row m-0 p-0" :style="hasBgconfig">
        <span class="text-center col-9 d-flex flex-column justify-content-center" style="font-size: 28px;">
          {{ params_msg }} {{ caixa }}
        </span>
        <strong class="col-auto mx-auto d-flex  align-items-center">
          <span class="mr-2 border p-1" v-if="pedv.comanda"
            ><i class="fa fa-barcode mr-1"></i>{{ pedv.comanda }}</span
          >
          <span class="mr-2 border p-1" v-if="pedv.mesa"
            ><i class="fa fa-table mr-1"></i>{{ pedv.mesa }}</span
          >
          <!-- <span style="font-size: 15px;"> Pedido: {{pedv.npedido}}</span> -->
        </strong>
      </div>

      <div
        class="float-right"
        style="display: flex; flex-direction: row; justify-content: end;"
      >
        <!-- <a
          class=""
          style="cursor: pointer; color: #fff; background: none"
          ref="botao"
          :tabindex="tabindex"
          title="Pressione F11 para entrar no Modo Full Screen"
          data-toggle="tooltip"
          data-placement="top"
          @click="handleFullScreen"
          ><i
            class="fa"
            :class="isFullScreen ? 'fa fa-compress' : 'fa fa-expand'"
            aria-hidden="true"
            :style="`${hasFontconfig}; font-size: 1.125rem`"
          ></i>
        </a> -->
        <!-- <button class="exit-button shadow" @click="handleHome">
            <span class="fa fa-close"></span>
            <span style="font-weight: 600;">Sair</span>
          </button> -->
        <button
          v-if="showBtnConfig"
          :style="hasFontconfig"
          @click="handleConfig"
          class="navbar-toggler"
          type="button">
          <span class="fa fa-cog"></span>
        </button>
        <button
          :style="hasFontconfig"
          @click="handleFullScreen"
          class="navbar-toggler"
          type="button">
          <span
            :class="isFullScreen ? 'fa fa-compress' : 'fa fa-expand'"
          ></span>
        </button>
        <button
          v-if="showBtnConfig"
          :style="hasFontconfig"
          @click="handleClose"
          class="navbar-toggler"
          type="button">
          <span class="fa fa-close"></span>
        </button>
      </div>
    </nav>
  </div>
</template>

<style scoped>
.zindextop {
  z-index: 99999;
}

.exit-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border-radius: 5px;
  gap: 5px;
  background-color: #ffffff23;
  color: #ffff;
  margin: 5px;
  padding-inline: 24px;
}

.nb-menu-config {
  color: #9c9a9a;
  font-size: 18px;
}

.nb-menu-title {
  color: #c2c4c5;
  font-size: 15px;
  padding: 0.5rem 1.5rem;
  background-color: #2b6292;
}

.nb-dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  color: #c2c4c5;
  font-size: 85%;
  background: #2b6292;
  white-space: nowrap;
  text-align: center;
}

.columns-1 {
  min-width: 250px;
}

.columns-2 {
  min-width: 500px;
}

.columns-3 {
  min-width: 700px;
}

.left-divider {
  width: 1;
  /* margin: 0.5rem 0; */
  overflow: hidden;
  border-left: 1px solid #e9ecef;
}

.nb-dropdownmenu {
  /* background: #ffffff; */
  width: 100%;
}

.nb-dropdownmenu ul,
.nb-dropdownmenu li {
  margin: 0;
  padding: 0;
}
.nb-dropdownmenu ul {
  background: #ffffff;
  list-style: none;
  width: 100%;
}
.nb-dropdownmenu li {
  float: left;
  position: relative;
  width: auto;
}

.nb-dropdownmenu span,
a {
  background: #ffffff;
  /* color: #2b6292; */
  color: gray;
  display: block;
  font-size: 12px;
  font-weight: 600;
  line-height: 40px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 0px 25px;
  text-decoration: none;
  white-space: nowrap;
  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -ms-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

.nb-dropdownmenu li:hover a {
  background: #2b6292;
  color: #ffffff;
}

.nb-dropdown-divider {
  background: #2b6292;
  width: 1;
  overflow: hidden;
  border-bottom: 1px solid #e9ecef;
}

#submenu {
  left: 0;
  opacity: 0;
  position: absolute;
  /* top: 35px; */
  visibility: hidden;
  background: #2b6292;
  padding: 25px 0px;
  z-index: 1000;
}
li:hover ul#submenu {
  opacity: 1;
  top: 40px; /* adjust this as per top nav padding top & bottom comes */
  visibility: visible;
}
#submenu li {
  float: none;
  width: 100%;
}
#submenu a:hover {
  background: #2b629285;
}

#submenu a {
  background-color: #2b6292;
}

#submenu .row {
  background: #2b6292;
  margin-right: 0;
  margin-left: 0;
}
#submenu .submenu-col-2 {
  flex: 0 0 50%;
  max-width: 50%;
}
#submenu .submenu-col-3 {
  flex: 0 0 33.33%;
  max-width: 33.33%;
}
#submenu.submenu-right {
  right: 0;
  left: auto;
}

.mobile-device {
  display: block;
}

.other-device {
  display: none;
}

@media (min-width: 768px) {
  .mobile-device {
    display: none;
  }
  .other-device {
    display: block;
  }
}

.submenu-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  color: gray;
  /* font-size: 85%; */
  /* background:#2b6292; */
  font-weight: 700;
  white-space: nowrap;
  text-align: center;
}

.menu-user {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  color: #c2c4c5;
  font-size: 120%;
  font-weight: 600;
  background: #2b6292;
  /* white-space: nowrap; */
  /* text-align: center; */
}

.menu-email {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  color: #c2c4c5;
  font-size: 85%;
  font-weight: 600;
  background: #2b6292;
  /* white-space: nowrap; */
  /* text-align: center; */
}

.close {
  font-size: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/varejo-bar-top.vue